/// <amd-module name="Artifacts/Sample/redux/Contracts" />

import { IVSSPageDataAwareState } from "VSS/Redux/Modules/VSSPageData";

export interface ISampleComponentState {
  hello: string;
}

export interface ISampleReducerMap {
  simpleState: ISampleComponentState;
}

export type ISampleReduxState = ISampleReducerMap & IVSSPageDataAwareState;
